/* eslint-disable react/prop-types */
import React, { createContext, ReactChild, ReactChildren, useEffect, useReducer } from 'react';
import { PropertyInfoReducer, PropertyInfoReducerType } from '../reducers/PropertyInfoReducer';
import { LocalStorageKeys, readLocalStorage, setLocalStorage } from '../utils/localStorageHelper';
import { Address, PropertyInfoContextDto } from './dtos/PropertyInfoContextDto';

export const PropertyInfoContext = createContext<{ state: PropertyInfoContextDto; dispatch: React.Dispatch<PropertyInfoReducerType> }>({
  state: new PropertyInfoContextDto(),
  dispatch: () => undefined,
});

const ListPropertyProvider = (props: AuxProps) => {
  const [propertyInfo, dispatch] = useReducer(PropertyInfoReducer, new PropertyInfoContextDto(), () => {
    if (typeof window !== 'undefined') {
      const localData = readLocalStorage<PropertyInfoContextDto>(LocalStorageKeys.PropertyInfoContext, new PropertyInfoContextDto());
      const result = new PropertyInfoContextDto();
      // necessary to avoid cast to use methods
      Object.assign(result, localData);

      const oldAddress = result.address;
      result.address = new Address();
      Object.assign(result.address, oldAddress);

      return result;
    }
    return new PropertyInfoContextDto();
  });

  useEffect(() => {
    // console.log('UseEffect PropertyInfoContext', propertyInfo);
    setLocalStorage(LocalStorageKeys.PropertyInfoContext, propertyInfo);
  }, [propertyInfo]);

  return <PropertyInfoContext.Provider value={{ state: propertyInfo, dispatch }}>{props.children}</PropertyInfoContext.Provider>;
};

export default ListPropertyProvider;

export interface AuxProps {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
}
